import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag } from 'antd';

import Button from '@material-ui/core/Button';

import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

import ReferrerStore from './ReferrerStore';

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width: 100,
};

const columnDefs = [
    { headerName: 'Referrer ID', field: 'ReferrerId', pinned: 'left', type: 'numberColumn' },
    { headerName: 'Referrer Name', field: 'ReferrerName', filter: 'agTextColumnFilter', pinned: 'left', width: 300 },
    { headerName: 'Credit Limit', field: 'CreditLimit', width: 50 },
    { headerName: 'Due', field: 'Dueamount', width: 50 },
    { headerName: 'Lock Status', field: 'Lock', width: 150 }
];

class LockedReferrerUI extends Component {

    gridRef = React.createRef();

    drop() {
        alert("BUTTON CLICKEFD")
    }

    constructor(props) {
        super(props);
        this.store = new ReferrerStore({ apiProxy: props.appStore.apiProxy })
    }

    fetchReferrerData = () => {
        this.store.fetchReferrers();
    }

    countTag = () => {
        if (this.store.isDone) {
            return <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    onLockChange = (referrerId, lock) => {

        const payLoad = {
            ReferrerId: referrerId,
            Lock: lock
        }

        this.store.updateLock(payLoad);

    }

    ButtonActionRenderer = (props) => {

        const rowData = props.data;
        const Lock = rowData.Lock;
        const referrer = rowData.ReferrerId;

        if (this.props.appStore.isHead) {

            if (Lock === 'Locked') {
                return (
                    <div>
                        <Button variant="contained" color="primary" style={{ height: '25px', width: '40%', textAlign: 'match-parent' }} onClick={() => this.onLockChange(referrer, 2)}>Permit</Button>
                    </div>
                );
            }

            return (
                <div>
                    <Button variant="contained" color="primary" style={{ height: '25px', width: '40%', textAlign: 'match-parent' }} onClick={() => this.onLockChange(referrer, 1)}>Lock</Button>
                </div>
            );
        }

        return (<div></div>);

    }

    render() {
        const referrers = this.store.referrers;
        const ButtonActionRenderer = this.ButtonActionRenderer;
        return (
            <>
                <PageHeader
                    style={pageHeaderStyle}
                    title={pageTitle("Locked Referrers")}
                    tags={this.countTag()}
                >
                </PageHeader>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={40}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={referrers}
                        rowSelection={'single'}
                        columnDefs={[...columnDefs,
                        {
                            headerName: "Action",
                            field: "Lock",
                            width: 80,
                            cellRenderer: "ButtonActionRenderer",
                        }]}
                        frameworkComponents={{
                            ButtonActionRenderer,
                        }}
                        onGridReady={this.fetchReferrerData}>
                    </AgGridReact>
                </div>
            </>
        )
    }
}

export default observer(LockedReferrerUI)
